"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _PageHeader = require("./PageHeader.styled");
var PageHeader = exports.PageHeader = function PageHeader(_ref) {
  var imageURL = _ref.imageURL,
    headerText = _ref.headerText,
    subHeaderText = _ref.subHeaderText,
    children = _ref.children,
    style = _ref.style,
    theme = _ref.theme,
    backLinkHref = _ref.backLinkHref;
  return /*#__PURE__*/_react["default"].createElement(_PageHeader.HeaderWrapper, {
    style: style,
    theme: theme
  }, backLinkHref && /*#__PURE__*/_react["default"].createElement(_PageHeader.BackLink, {
    href: backLinkHref
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faArrowLeft
  }), "Back"), imageURL ? /*#__PURE__*/_react["default"].createElement(_PageHeader.HeaderImage, {
    src: "".concat(imageURL),
    alt: "Image showing the logo of the event."
  }) : /*#__PURE__*/_react["default"].createElement(_PageHeader.ImagePlaceholder, null), /*#__PURE__*/_react["default"].createElement(_PageHeader.TextWrapper, {
    subHeaderText: subHeaderText
  }, /*#__PURE__*/_react["default"].createElement("h2", null, headerText), subHeaderText && /*#__PURE__*/_react["default"].createElement("p", {
    className: "sub-text"
  }, subHeaderText)), /*#__PURE__*/_react["default"].createElement(_PageHeader.ChildrenWrapper, {
    theme: theme
  }, children));
};
PageHeader.defaultProps = {
  subHeaderText: '',
  style: {},
  children: null,
  theme: 'dark',
  backLinkHref: null
};
PageHeader.propTypes = {
  theme: _propTypes["default"].oneOf(['light', 'dark']),
  subHeaderText: _propTypes["default"].string,
  headerText: _propTypes["default"].string.isRequired,
  imageURL: _propTypes["default"].string,
  style: _propTypes["default"].object,
  children: _propTypes["default"].node,
  backLinkHref: _propTypes["default"].string
};